import React, { Component } from 'react';
import styled from 'styled-components';
import firebase from 'firebase';

import { Button, TextInput } from './../lib/index';

const RootContainer = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  padding: 20px;
  flex-direction: column;
`;

const HeadLine = styled.h1``;

const AddNewsModal = styled.div`
  align-items: center;
  background-color: #000000dd;
  bottom: 0;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 99;
`;

const ButtonRootContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ButtonContainer = styled.div`
  display: inline-flex;
  margin-bottom: 20px;
`;

const AddNewsCard = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  max-width: 600px;
  padding: 20px;
  width: 100%;
  overflow: scroll;
  max-height: 600px;
`;
const NewsItemRootContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const NewsItemContainer = styled.div`
  display: flex;
  width: 375px;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px 0px #888888;
  flex-direction: column;
  margin-bottom: 50px;
`;

const NewsItemHeaderImage = styled.img`
  height: 229px;
  width: 375px;
  margin-bottom: 20px;
  display: block;
`;

const NewsTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex: 1;
  justify-content: space-between;
`;

const NewsItemTitle = styled.h3`
  color: #000000;
  margin-top: 0;
`;

const NewsItemDate = styled.h5`
  color: #6d7278;
  margin-top: 0;
`;

const NewsItemBookingUrlContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const NewsItemBookingUrl = styled.a`
  display: inline-block;
  background-color: #edba5d;
  padding: 20px;
  color: #ffffff;
  border-radius: 5px;
  width: 100px;
  text-align: center;
`;

const NewsItemActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const NewsItemActionButton = styled.button`
  background-color: ${props => (props.color ? props.color : '#edba5d')};
  border: none;
  color: #ffffff;
  display: inline-block;
  font-size: 20px;
  padding: 15px;
  width: 100px;
  border-radius: 5px;
  &:hover {
    background-color: ${props => (props.color ? props.color + 90 : '#edba5d')};
    cursor: pointer;
  }
`;

const ModalProgressContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #00000090;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const ShowProgress = styled.div`
  height: 100px;
  width: 200px;
  background-color: #ffffff;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class MapView extends Component {
  constructor() {
    super();

    this.state = {
      maps: [],
      addModal: false,
      editModal: false,
      title: '',
      category: '',
      latitude: '',
      longitude: '',
      order: '',
      upload: 0,
      editItemId: '',
      requiredField: false
    };
  }

  handleAddNewsModal = () => {
    this.setState({ addModal: !this.state.addModal });
  };

  removeNews = id => {
    if (window.confirm('Are you sure you want to remove this item?')) {
      console.log('______id', id);

      const db = firebase.firestore();
      const ref = db
        .collection('map')
        .doc(id)
        .delete()
        .then(() => {
          console.log('___removed news');
          this.handleFetchNews();
        })
        .catch(error => {
          console.log('____error', error);
        });
    }
  };

  addNews = () => {
    if (
      !this.state.title == '' &&
      !this.state.category == '' &&
      !this.state.latitude == '' &&
      !this.state.order == '' &&
      !this.state.longitude == ''
    ) {
      /* ----------------- */
      const db = firebase.firestore();
      const ref = db.collection('map').add({
        title: this.state.title,
        category: this.state.category,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        order: this.state.order
      });
      ref.then(data => {
        const state = { ...this.state };
        state.maps = [];
        state.addModal = false;
        state.title = '';
        state.category = '';
        state.latitude = '';
        state.order = '';
        state.longitude = '';
        state.upload = 0;
        this.setState(
          {
            ...state
          },
          () => this.handleFetchNews()
        );
      });
    } else {
      console.log('____________false add news');
      this.setState({ requiredField: true });
    }
  };

  handleChangeTextInput = (e, name) => {
    this.setState({ [name]: e.target.value });
  };

  handleFetchNews = () => {
    const db = firebase.firestore();
    const ref = db.collection('map').get();

    const state = { ...this.state };
    state.maps = [];
    ref.then(snap => {
      snap.forEach(doc => {
        console.log('________doc', doc);

        const docItem = {
          mapId: doc.id,
          title: doc.data().title,
          category: doc.data().category,
          latitude: doc.data().latitude,
          longitude: doc.data().longitude,
          order: doc.data().order
        };

        state.maps.push(docItem);
      });

      this.setState({ ...state });
    });
  };

  editItem = itemId => {
    const state = { ...this.state };
    state.editModal = true;
    const db = firebase.firestore();
    const ref = db
      .collection('map')
      .doc(itemId)
      .get();

    ref.then(doc => {
      state.title = doc.data().title;
      state.category = doc.data().category;
      state.latitude = doc.data().latitude;
      state.longitude = doc.data().longitude;
      state.order = doc.data().order;
      state.editItemId = itemId;
      this.setState({ ...state });
    });
  };

  handleCancelEditItemModal = () => {
    const state = { ...this.state };
    state.editModal = false;
    state.title = '';
    state.category = '';
    state.latitude = '';
    state.order = '';
    state.longitude = '';
    state.upload = 0;
    state.editItemId = '';

    this.setState({ ...state });
  };

  updateItem = () => {
    const state = { ...this.state };
    const db = firebase.firestore();
    const ref = db
      .collection('map')
      .doc(state.editItemId)
      .update({
        title: this.state.title,
        category: this.state.category,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        order: this.state.order
      });
    ref.then(res => {
      state.editModal = false;
      state.title = '';
      state.category = '';
      state.latitude = '';
      state.order = '';
      state.longitude = '';
      state.upload = 0;
      state.editItemId = '';

      this.setState({ ...state }, () => this.handleFetchNews());
    });
  };

  componentDidMount() {
    this.handleFetchNews();
  }

  render() {
    return (
      <RootContainer>
        <HeadLine>Map</HeadLine>
        <ButtonContainer>
          <Button
            title="Add map point"
            color="#56bc6f"
            onClick={() => this.handleAddNewsModal()}
          ></Button>
        </ButtonContainer>

        {this.state.maps.length > 0 ? (
          <div>
            <NewsItemRootContainer>
              {this.state.maps.map((mapsItem, index) => {
                return (
                  <NewsItemContainer key={index}>
                    <NewsTextContainer>
                      <NewsItemTitle>{mapsItem.title}</NewsItemTitle>
                      <NewsItemDate>
                        Category : {mapsItem.category}
                      </NewsItemDate>
                      <NewsItemDate>Latitude :{mapsItem.latitude}</NewsItemDate>
                      <NewsItemDate>
                        Longitude :{mapsItem.longitude}
                      </NewsItemDate>
                      <NewsItemDate>Order :{mapsItem.order}</NewsItemDate>

                      <NewsItemActionContainer>
                        <NewsItemActionButton
                          onClick={() => this.editItem(mapsItem.mapId)}
                          color="#03a9f4"
                        >
                          Edit
                        </NewsItemActionButton>
                        <NewsItemActionButton
                          color="#ff0000"
                          onClick={() => this.removeNews(mapsItem.mapId)}
                        >
                          Remove
                        </NewsItemActionButton>
                      </NewsItemActionContainer>
                    </NewsTextContainer>
                  </NewsItemContainer>
                );
              })}
            </NewsItemRootContainer>
          </div>
        ) : null}

        {this.state.addModal ? (
          <AddNewsModal>
            <AddNewsCard>
              <HeadLine>Add map points</HeadLine>
              <TextInput
                type="text"
                title="Title"
                value={this.state.title}
                onChange={e => this.handleChangeTextInput(e, 'title')}
                required
                border={
                  this.state.requiredField && this.state.title.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Category"
                value={this.state.category}
                onChange={e => this.handleChangeTextInput(e, 'category')}
                required
                border={
                  this.state.requiredField && this.state.category.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Latitude"
                value={this.state.latitude}
                onChange={e => this.handleChangeTextInput(e, 'latitude')}
                required
                border={
                  this.state.requiredField && this.state.latitude.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Longitude"
                value={this.state.longitude}
                onChange={e => this.handleChangeTextInput(e, 'longitude')}
                required
                border={
                  this.state.requiredField && this.state.longitude.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Order"
                value={this.state.order}
                onChange={e => this.handleChangeTextInput(e, 'order')}
                required
                border={
                  this.state.requiredField && this.state.order.length < 1
                    ? true
                    : false
                }
              ></TextInput>
              <ButtonRootContainer>
                <ButtonContainer>
                  <Button
                    title="Cancel"
                    onClick={() => this.handleAddNewsModal()}
                  ></Button>
                </ButtonContainer>
                <ButtonContainer>
                  {this.state.upload > 0 ? (
                    <ModalProgressContainer>
                      <ShowProgress>
                        Uploading : {this.state.upload.toFixed(1)} %
                      </ShowProgress>
                    </ModalProgressContainer>
                  ) : null}
                  <Button
                    title="Add"
                    color="#56bc6f"
                    onClick={() => this.addNews()}
                  ></Button>
                </ButtonContainer>
              </ButtonRootContainer>
            </AddNewsCard>
          </AddNewsModal>
        ) : null}

        {this.state.editModal ? (
          <AddNewsModal>
            <AddNewsCard>
              <HeadLine>Add map points</HeadLine>
              <TextInput
                type="text"
                title="Title"
                value={this.state.title}
                onChange={e => this.handleChangeTextInput(e, 'title')}
                required
                border={
                  this.state.requiredField && this.state.title.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Category"
                value={this.state.category}
                onChange={e => this.handleChangeTextInput(e, 'category')}
                minlength="5"
                required
                border={
                  this.state.requiredField && this.state.category.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Latitude"
                value={this.state.latitude}
                onChange={e => this.handleChangeTextInput(e, 'latitude')}
                minlength="5"
                required
                border={
                  this.state.requiredField && this.state.latitude.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Longitude"
                value={this.state.longitude}
                onChange={e => this.handleChangeTextInput(e, 'longitude')}
                minlength="5"
                required
                border={
                  this.state.requiredField && this.state.longitude.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <TextInput
                type="text"
                title="Order"
                value={this.state.order}
                onChange={e => this.handleChangeTextInput(e, 'order')}
                required
                border={
                  this.state.requiredField && this.state.order.length < 5
                    ? true
                    : false
                }
              ></TextInput>
              <ButtonRootContainer>
                <ButtonContainer>
                  <Button
                    title="Cancel"
                    onClick={() => this.handleCancelEditItemModal()}
                  ></Button>
                </ButtonContainer>
                <ButtonContainer>
                  {this.state.upload > 0 ? (
                    <ModalProgressContainer>
                      <ShowProgress>
                        Uploading : {this.state.upload.toFixed(1)} %
                      </ShowProgress>
                    </ModalProgressContainer>
                  ) : null}
                  <Button
                    title="Update"
                    color="#56bc6f"
                    onClick={() => this.updateItem()}
                  ></Button>
                </ButtonContainer>
              </ButtonRootContainer>
            </AddNewsCard>
          </AddNewsModal>
        ) : null}
      </RootContainer>
    );
  }
}

export default MapView;
